/**
 * Opening something from the phone's calendar — `docs/activity.md` §10.3, §8.2.
 *
 * Its own module so the phone calendar and the Month and List it mounts
 * (Aaron, Oct 25, phone notes 3.2, 3.3) can all open a stop without
 * importing each other.
 */
import type { CalendarItem } from '@rowted/shared'
import { openTaskSheet } from '../tasks/task-sheet.js'

/**
 * A stop was tapped: the stop page opens over the calendar (§10.3, Board 14
 * A). `id` may be an occurrence's key (`<id>@<its own day>`), so a repeating
 * meeting's page says that day's time, moved or not.
 */
export const ACTIVITY_STOP_EVENT = 'rowted:activity-stop'
export function openStop(id: string): void {
  window.dispatchEvent(new CustomEvent<{ id: string }>(ACTIVITY_STOP_EVENT, { detail: { id } }))
}

/**
 * What a tap on an item opens on the phone: a site visit or a meeting its
 * stop page, a task its Task sheet (§8.2). A time block opens nothing — it is
 * moved and removed from Day, where it has its length.
 */
export function openCalendarItem(item: CalendarItem): void {
  if (item.kind === 'appointment' || item.kind === 'meeting') openStop(item.key)
  else if (item.kind === 'task') openTaskSheet(item.id)
}

/** Whether a tap on the item opens something. */
export const opensOnTap = (item: CalendarItem): boolean => item.kind !== 'block'
